// extracted by mini-css-extract-plugin
module.exports = {"boxInput":"_2Nw_gttdGQREnf30S0rVGw","input":"_31Pfb5jy_kYypa4vAKlTIC"};